module.exports = __webpack_public_path__ + "img/09_2.b195e98c.png";